<template>
  <salary-statement-details :key="$route.params.id"
                            :id="+$route.params.id"
                            :default-date="defaultDate"
                            @dialog:close="close"
  ></salary-statement-details>
</template>

<script>
  import moment from 'moment'
  import {SERVER_DATE_FORMAT} from '@/filters'
  import SalaryStatementDetails from '@/modules/salary-statements-v2/details'

  // A salary statement on its own page (/salary-statements-2/:id?date=YYYY-MM-DD) instead of a dialog
  export default {
    name: 'salary-statement-v2-page',

    computed: {
      defaultDate() {
        const date = moment(this.$route.query.date, SERVER_DATE_FORMAT, true)
        return date.isValid() ? date.format(SERVER_DATE_FORMAT) : moment().format(SERVER_DATE_FORMAT)
      },
    },

    methods: {
      close() {
        this.$router.push({name: 'salary-statement-v2.list'})
      },
    },

    mounted() {
      this.$eventBus.$emit('setTitle', 'Зарплатная ведомость 2')
    },

    beforeDestroy() {
      this.$store.commit('SalaryStatement/setModel', {})
    },

    components: {
      SalaryStatementDetails,
    },
  }
</script>
